import React, { useState } from "react";
import { Form, Input, Button, Typography, message, Card } from "antd";
import { useNavigate } from "react-router-dom";
import { axiosForm } from "../../axiosInstances";
import Logo from "../common/Logo";
import AnimatedBackground from "./AnimatedBackground";

const { Title } = Typography;

const RegisterForm = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await axiosForm.post("authentication/api/register/", values, {
        withCredentials: true,
      });
      message.success("Inscription réussie ! Connectez-vous.");
      navigate("/login");
    } catch (error) {
      message.error(
        error.response?.data?.detail ||
          "Échec de l'inscription. Veuillez vérifier les informations saisies."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "transparent",
        position: "relative"
      }}
    >
      <AnimatedBackground />
      <Card
        style={{
          maxWidth: 400,
          width: "100%",
          padding: 24,
          borderRadius: 12,
          boxShadow: "0 2px 16px #0002",
          zIndex: 1,
          background: "#fff",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <Logo size={300} />
        </div>
        <Title level={3} style={{ textAlign: "center" }}>
          Inscription
        </Title>
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            label="Adresse email"
            name="email"
            rules={[
              { required: true, message: "Veuillez saisir une adresse email" },
              { type: "email", message: "L'email n'est pas valide" },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Mot de passe"
            name="password"
            rules={[{ required: true, message: "Veuillez saisir un mot de passe" }]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            label="Confirmer le mot de passe"
            name="confirm"
            dependencies={["password"]}
            hasFeedback
            rules={[
              { required: true, message: "Veuillez confirmer le mot de passe" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Les mots de passe ne correspondent pas"));
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item>
            <Button
              block
              type="primary"
              htmlType="submit"
              loading={loading}
              style={{ marginTop: 8 }}
            >
              S'inscrire
            </Button>
          </Form.Item>
          <div style={{ textAlign: "center" }}>
            Déjà un compte ? <a href="/login">Se connecter</a>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default RegisterForm;
